import { Injectable, OnDestroy } from '@angular/core';
import * as TillStatusSelectors from './till-status.selectors';
import { Action, select, Store } from '@ngrx/store';
import { TillStatusPartialState } from './till-status.reducer';
import {
  getSelectedOrganizationInfo,
  loadTillStatusFailure,
  loadTillStatusSuccess,
} from '@boma/supplier-portal/shared/state';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Actions, ofType } from '@ngrx/effects';

@Injectable({
  providedIn: 'root',
})
export class TillStatusFacade {
  isLoading$ = this.tillStatusStore.pipe(
    select(TillStatusSelectors.getTillStatusLoading),
  );
  isUpdatingStatus$ = this.tillStatusStore.pipe(
    select(TillStatusSelectors.getIsUpdatingTillStatus),
  );
  currentTillStatus$ = this.tillStatusStore.pipe(
    select(TillStatusSelectors.getTillStatus),
  );

  onTillStatusUpdateSuccess$ = this.tillStatusActions.pipe(
    ofType(loadTillStatusSuccess),
  );
  onTillStatusUpdateFailure$ = this.tillStatusActions.pipe(
    ofType(loadTillStatusFailure),
  );

  constructor(
    private tillStatusStore: Store<TillStatusPartialState>,
    private tillStatusActions: Actions,
    private store: Store,
  ) {}

  dispatch(action: Action) {
    this.tillStatusStore.dispatch(action);
  }
}
